import { HttpHelper } from "../../Core/Http/HttpHelper";
import { SystemCore } from "../../Core/System/SystemCore";
import sosmartLogo from '../../Assets/Images/favicon.svg';
import sosmartIcon from "../../Assets/Images/logo.png";
import eosLogo from "../../Assets/Images/download.png";
import eosIcon from "../../Assets/Images/favicon.png";
import soSmartSend from "../../Assets/Images/SoSmartSend.svg";
import eosSend from "../../Assets/Images/EosSend.svg";


const ssoRootBackground = "#2A7DE1";
const ssoQuestionBackground = "#2A7DE1";
const ssoRootHoveredBackground = "#005A9E";
const ssoRootPressedBackground = "#004080";
const eosRootBackground = "radial-gradient(109.81% 107.82% at 100.1% 90.19%, #ff6d00 33.63%, #e34e00 70.31%, #ff9761 100%)";
const eosQuestionBackground = "#ff6d00";
const eosRootHoveredBackground = "linear-gradient(135deg, #ff6d00 0%, #e34e00 51.04%, #ff9761 100%)";
const eosRootPressedBackground = "linear-gradient(135deg, #cc5800 0%, #b33d00 51.04%, #cc7a4d 100%)";

export class ChatbotHelper
{
    public static handleContext()
    {
        let context = this.getContext(); 
        switch (context)
        {
            case ChatbotContext.SoSmart:
                break;
            case ChatbotContext.Eos:
                window.document.title = "Eos Solutions";
                SystemCore.setFavicons("data:image/png;base64,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");

                document.documentElement.style.setProperty('--chat-container-color', '#fde6db');
                document.documentElement.style.setProperty('--chat-font-family', '"Open Sans", sans-serif');
                document.documentElement.style.setProperty('--chat-usermessage-backgroundcolor', '#fae8da');

                document.documentElement.style.setProperty('--answer-font-family', '"Open Sans", sans-serif');

                document.documentElement.style.setProperty('--chat-question-font-family', '"Open Sans", sans-serif');
                document.documentElement.style.setProperty('--chat-question-color', '#ff6d00');
                document.documentElement.style.setProperty('--chat-question-border-primary-color', '#ff6d00');
                document.documentElement.style.setProperty('--chat-question-border-secondary-color', '#ff9761');
                break;
        }
    }

    public static getLogo = (): string => {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return sosmartLogo;
            case ChatbotContext.Eos:
                return eosLogo;
        }
    }

    public static getIcon = (): string => {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return sosmartIcon;
            case ChatbotContext.Eos:
                return eosIcon;
        }
    }

    public static getTitle() : string {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return "SoSmart";
            case ChatbotContext.Eos:
                return "Eos Solutions";
        }
    }

    public static getSendIcon() : string 
    {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return soSmartSend;
            case ChatbotContext.Eos:
                return eosSend;
        }
    }

    public static getQuestionBackground() : string
    {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return ssoQuestionBackground;
            case ChatbotContext.Eos:
                return eosQuestionBackground;
        }
    }

    public static getButtonBackground() : string
    {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return ssoRootBackground;
            case ChatbotContext.Eos:
                return eosRootBackground;
        }
    }

    public static getButtonHoveredBackground() : string
    {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return ssoRootHoveredBackground;
            case ChatbotContext.Eos:
                return eosRootHoveredBackground;
        }
    }

    public static getButtonPressedBackground() : string
    {
        let context = this.getContext();
        switch (context)
        {
            case ChatbotContext.SoSmart:
                return ssoRootPressedBackground;
            case ChatbotContext.Eos:
                return eosRootPressedBackground;
        }
    }

    public static getContext = () : ChatbotContext => {
        let context = HttpHelper.getParameter("context");
        if((context === "") || (context === null)){
            context = ChatbotContext.SoSmart;
        }
        
        if (window.location.origin === "https://eosapps.so-smart.it" || context === "Eos"){
            return ChatbotContext.Eos;
        }

        return context;
    }

    public static isPortalEnabled = () : boolean => {
        return !window.location.origin.includes("partner") && !window.location.origin.includes("distributor") && !window.location.origin.includes("admin");
    }
}

export enum ChatbotContext
{
    SoSmart = "SoSmart",
    Eos = "Eos"
}